export const saveObjectives = (payload) => ({
  type: 'SAVE_CAMPAIGN_OBJECTIVES',
  payload
})

export const saveHighlightedObjectives = (payload) => ({
  type: 'SAVE_CAMPAIGN_HIGHLIGHTED_OBJECTIVES',
  payload
})
